import { TEXTS } from '../helpers/content';
import { ContentWrapper, ContentTitle } from './ContentStyled';
import DoubleChance from './items/DoubleChance';
import BonusBuy from './items/BonusBuy';
// import FeatureDouble from "../assets/features/feature_double_chance.png"

export default function Features({ dimentions, config, currency, currentBet }) {
	return (
		<ContentWrapper scale={dimentions.scale}>
			<div style={{ margin: 'auto' }}>
				<ContentTitle scale={dimentions.scale}>
					{TEXTS.features[0].title}
				</ContentTitle>
			</div>
			<div className='features'>
				<DoubleChance
					scale={dimentions.scale}
					doubleChance={config.doublefeatureprice}
					currency={currency}
					currentBet={currentBet}
					config={config}
				/>
				<BonusBuy
					scale={dimentions.scale}
					buyfeatureprice={config.buyfeatureprice}
					currency={currency}
					currentBet={currentBet}
				/>
			</div>
		</ContentWrapper>
	);
}
